/**
 * replaces secessions of the same char at the end of the string
 * @param val
 * @param charToRemove
 */
const string_replaceAtEndRepeatedly = (
    val: string,
    charToRemove: string
): string => {
    return val
        .split(charToRemove)
        .reduce((prev, curr) => (curr ? [...prev, curr] : prev), [] as string[])
        .join(charToRemove);
};

export const cleanURL = (url: string) => {
    let ret = string_replaceAtEndRepeatedly(url, "/");
    ret = string_replaceAtEndRepeatedly(ret, "&");
    ret = string_replaceAtEndRepeatedly(ret, "#");
    ret = string_replaceAtEndRepeatedly(ret, "?");

    return ret;
};

export const formatRelativeTime = (createdOn: number): string => {
    const elapsedSeconds = Math.max(
        0,
        Math.floor((Date.now() - createdOn) / 1000)
    );
    if (elapsedSeconds < 60) return "1m";

    const elapsedMinutes = Math.floor(elapsedSeconds / 60);
    if (elapsedMinutes < 60) return `${elapsedMinutes}m`;

    const elapsedHours = Math.floor(elapsedMinutes / 60);
    if (elapsedHours < 24) return `${elapsedHours}h`;

    const elapsedDays = Math.floor(elapsedHours / 24);
    if (elapsedDays < 7) return `${elapsedDays}d`;

    const elapsedWeeks = Math.floor(elapsedDays / 7);
    if (elapsedWeeks < 5) return `${elapsedWeeks}w`;

    const elapsedMonths = Math.floor(elapsedDays / 30);
    if (elapsedMonths < 12) return `${elapsedMonths}mo`;

    return `${Math.floor(elapsedDays / 365)}y`;
};

/**
 * Debouncing helps avoid multiple calls during rapid input changes.
 */
type TDebounce = {
    func: (...args: any[]) => void;
    delay: number;
};
export const debounce = ({
    func,
    delay,
}: TDebounce): ((...args: any[]) => void) => {
    let timeoutId: ReturnType<typeof setTimeout>;

    return (...args: any[]) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};
